import { useEffect, useState } from "react";
import { ref, getDownloadURL } from 'firebase/storage';
import { 
    MdModeEditOutline, MdDelete
} from "react-icons/md";
import EditDish from "./Editor/EditDish";
import noPicture from './Editor/images/no_picture.jpg';

const Dish = (props) => {

    const [picture, setPicture] = useState(props.data.picture?props.data.picture:'');

    const editDish = (dish) => {
        props.callback.showPopup('Editar Platillo', <EditDish dish={dish} resID={props.resID} picture={picture} setPicture={setPicture} eDB={props.eDB} storage={props.storage} dishlist={props.dishlist} setDishlist={props.setDishList} close={props.callback.closePopup}/>);
    };

    const deleteDish = (dish) => {
        props.callback.showPopup('Eliminar Platillo', <EditDish dish={dish} resID={props.resID} picture={picture} eDB={props.eDB} storage={props.storage}  dishlist={props.dishlist} setDishlist={props.setDishList} close={props.callback.closePopup} delete/>);
    }

    useEffect(() => {
        //Get Current Front
        const pictureRef = ref(props.storage, `Restaurants/${props.resID}/MenuPictures/${props.data.picture}`);
        
        getDownloadURL(pictureRef).then((url) => {
            setPicture(url);
        }).catch((error) => {
            setPicture(undefined);
            console.log("Unable to get the photoURL");
        });
    }, [props.data, props.resID, props.storage]);

    return(
        <>
        <div className="d-flex">
            <div className="Dish mr-1">
                <div className='EditTools'>
                    <button onClick={() => editDish(props.data)} className="cbtn"><MdModeEditOutline size='1rem' pointerEvents='none'/></button>
                    <button onClick={() => deleteDish(props.data)} className="cbtn"><MdDelete size='1rem' pointerEvents='none'/></button>
                </div>

                <div style={{overflow: 'hidden', textAlign: 'center'}} >
                    <img src={picture?picture:noPicture} width='100%' alt={props.data.name}/>
                </div>

                <div className="d-flex px-1">
                    <div className="d-flex m-auto dish-label pr-1"><strong>{props.data.name}</strong></div>
                    <div className="d-flex m-auto dish-label">{'Q.'+props.data.price}</div>
                </div>
            </div>
        </div>
        </>
    );
}

export default Dish;